import { useQuery } from '@tanstack/react-query';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { listMcpGatewayTools } from '@/services/mcp-gateway';
import type { McpGatewayTool } from '@/services/mcp-gateway';

export function useMcpTools() {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useQuery<McpGatewayTool[]>({
    queryKey: ['mcp-tools', orgId],
    queryFn: () => listMcpGatewayTools(orgId),
    enabled: !!orgId,
    staleTime: 60_000,
    retry: false,
  });
}
